import React from 'react'
import { ListGroup } from 'react-bootstrap'
import * as styles from './SurvivorStandingsDivider.scss'

const SurvivorStandingsDivider = ({ contest }) => <ListGroup.Item role='separator' aria-label={`${contest === 'Terminator' ? 'Terminated' : 'Eliminated'} players`} className={styles.divider}>
  <span>{contest === 'Terminator' ? 'Terminated' : 'Eliminated'} players</span>
</ListGroup.Item>
export default SurvivorStandingsDivider
